"use client";

import { Row, Col, Card, Button } from 'antd/lib';
import Image from "next/image";
import LinkedInIcon from "../../public/common/linkedin.svg";
import TwitterIcon from "../../public/common/twitter.svg";


import './team.styles.scss';

const { Meta } = Card;

export default function Team() {


  return (
    <div className="team-container">
      <Row className="team-row">
        <Col
          xs={{ span: 24 }}
          md={{ span: 24 }}
          sm={{ span: 24 }}
          lg={{ span: 24 }}
          className="ant-col-team-row"
        >
          <Row className="team-row-wrapper">
            <h5 className="team-title">
              MEET THE TEAM
            </h5>
            <h1 className="team-subtitle">
              Greg Token Core Team
            </h1>
          </Row>
          <Row className="team-row-about">
            <h3 className="team-about-text">
              At Greg, we believe that the path to a sustainable future is built by communities, for communities. Our team, united by a shared vision, is dedicated to bringing the benefits of renewable energy ownership to those who truly care.
            </h3>
          </Row>
          
          <Row className="team-row-members"  style={{paddingLeft: 100}}>
            <Col
              xs={{ span: 8 }}
              md={{ span: 8 }}
              sm={{ span: 8 }}
              lg={{ span: 8 }}

            >
              <Card
                className="team-card-container"
                cover={
                  <div style={{backgroundColor: "black", height: 200, width: 200, borderRadius: "50%"}}></div>
                  // <Image
                  //     src="/home/andrew-img.jpg"
                  //     width={500}
                  //     height={500}
                  //     alt="team introduction"
                  //     className="team-card-img"
                  // />
                }
              >
                <Meta
                  title={
                    <div className="team-card-wrapper">
                      <h2 className="team-card-name">
                        Andrew
                      </h2>
                      <h5 className="team-card-role">
                        Co-Founder, CEO
                      </h5>
                    </div>      
                  }
                />
                  <div className="team-card-overlay">
                    <div className="team-card-overlay-content">
                      <p className="team-card-overlay-text">
                        xx
                      </p>
                      <div className="team-card-overlay-icon">
                        <LinkedInIcon />
                        <TwitterIcon />
                      </div>
                    </div>
                  </div>
              </Card>
            </Col>

            <Col
              xs={{ span: 8 }}
              md={{ span: 8 }}
              sm={{ span: 8 }}
              lg={{ span: 8 }}
            >
              <Card
                className="team-card-container"
                cover={
                     <div style={{backgroundColor: "black", height: 200, width: 200, borderRadius: "50%"}}></div>
                  // <Image
                  //     src="/home/andrew-img.jpg"
                  //     width={500}
                  //     height={500}
                  //     alt="team introduction"
                  //     className="team-card-img"
                  // />
                }
              >
                <Meta
                  title={
                    <div className="team-card-wrapper">
                      <h2 className="team-card-name">
                        Alex
                      </h2>
                      <h5 className="team-card-role">
                        Co-Founder, CTO
                      </h5>
                    </div>      
                  }
                />
                  <div className="team-card-overlay">
                    <div className="team-card-overlay-content">
                      <p className="team-card-overlay-text">
                        xx
                      </p>
                      <div className="team-card-overlay-icon">
                        <LinkedInIcon />
                        <TwitterIcon />
                      </div>
                    </div>
                  </div>
              </Card>
            </Col>
          </Row>
          
          {/* SECOND ROW TEAM MEMBERS */}

          <Row className="team-row-members" style={{paddingLeft: 100}}>

            <Col
              xs={{ span: 8 }}
              md={{ span: 8 }}
              sm={{ span: 8 }}
              lg={{ span: 8 }}
            >
              <Card
                className="team-card-container"
                cover={
                  <div style={{backgroundColor: "black", height: 200, width: 200, borderRadius: "50%"}}></div>
                  // <Image
                  //     src="/home/andrew-img.jpg"
                  //     width={500}
                  //     height={500}
                  //     alt="team introduction"
                  //     className="team-card-img"
                  // />
                }
              >
                <Meta
                  title={
                    <div className="team-card-wrapper">
                      <h2 className="team-card-name">
                        Tyron
                      </h2>
                      <h5 className="team-card-role">
                        Co-Founder, CMO
                      </h5>
                    </div>      
                  }
                />
                  <div className="team-card-overlay">
                    <div className="team-card-overlay-content">
                      <p className="team-card-overlay-text">
                        xx 
                      </p>
                      <div className="team-card-overlay-icon">
                        <LinkedInIcon />
                        <TwitterIcon />
                      </div>
                    </div>
                  </div>
              </Card>
            </Col>

            <Col
              xs={{ span: 8 }}
              md={{ span: 8 }}
              sm={{ span: 8 }}
              lg={{ span: 8 }}
            >
              <Card
                className="team-card-container"
                cover={
                  <div style={{backgroundColor: "black", height: 200, width: 200, borderRadius: "50%"}}></div>
                  // <Image
                  //     src="/home/andrew-img.jpg"
                  //     width={500}
                  //     height={500}
                  //     alt="team introduction"
                  //     className="team-card-img"
                  // />
                }
              >
                <Meta
                  title={
                    <div className="team-card-wrapper">
                      <h2 className="team-card-name">
                        Tich
                      </h2>
                      <h5 className="team-card-role">
                        FullStack Dev
                      </h5>
                    </div>      
                  }
                />
                  <div className="team-card-overlay">
                    <div className="team-card-overlay-content">
                      <p className="team-card-overlay-text">
                       xx
                      </p>
                      <div className="team-card-overlay-icon">
                        <LinkedInIcon />
                        <TwitterIcon />
                      </div>
                    </div>
                  </div>
              </Card>
            </Col>

            <Col
              xs={{ span: 8 }}
              md={{ span: 8 }}
              sm={{ span: 8 }}
              lg={{ span: 8 }}
            >
              <Card
                className="team-card-container"
                cover={
                  <div style={{backgroundColor: "black", height: 200, width: 200, borderRadius: "50%"}}></div>
                  // <Image
                  //     src="/home/andrew-img.jpg"
                  //     width={500}
                  //     height={500}
                  //     alt="team introduction"
                  //     className="team-card-img"
                  // />
                }
              >
                <Meta
                  title={
                    <div className="team-card-wrapper">
                      <h2 className="team-card-name">
                        James
                      </h2>
                      <h5 className="team-card-role">
                        Lead Designer
                      </h5>
                    </div>      
                  }
                />
                  <div className="team-card-overlay">
                    <div className="team-card-overlay-content">
                      <p className="team-card-overlay-text">
                        xx 
                      </p>
                      <div className="team-card-overlay-icon">
                        <LinkedInIcon />
                        <TwitterIcon />
                      </div>
                    </div>
                  </div>
              </Card>
            </Col>

          </Row>
        </Col>
      </Row>
    </div>
  );
}